// extracted by mini-css-extract-plugin
module.exports = {"filter":"CuadernillosCliente_filter__Vhq7F"};